import './BannerAbout.scss';
import React from 'react';
import Button from 'Components/Shared/Button/Button';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  aboutContent: Julius.Content.Banner;
  localPathAbout: string;
  localPathContact: string;
}

const BannerAbout: React.SFC<IProps> = ({
  aboutContent,
  localPathAbout,
  localPathContact,
}) => {

  if (!aboutContent) {
    return null;
  }

  return (
    <WrapperLayout style='banner-about' justify='center' align='middle' padding='md'>
      <span className='title'>{ aboutContent.title }</span>
      <span className='text' dangerouslySetInnerHTML={ { __html: aboutContent.text } } />
      <div>
        <Button localPath={ localPathAbout } size='large' boxShadow={ true }>
          <FormattedText
            displayName='Mer om oss'
            formattedName='global.moreaboutus'
          />
        </Button>
        <Button localPath={ localPathContact } size='large' boxShadow={ true } color='black' >
          <FormattedText
            displayName='Kontakta oss'
            formattedName='global.contactus'
          />
        </Button>
      </div>
    </WrapperLayout>
  );
};

export default BannerAbout;


// WEBPACK FOOTER //
// ./src/components/BannerAbout/BannerAbout.tsx